import cn from 'classnames';

const Paso = ({ number = '1', bgColor = 'bg-red' }) => {
  return (
    <div className={cn('w-44 h-44 relative rounded-full', bgColor)}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <p className="p1 text-white">{number}.</p>
      </div>
    </div>
  );
};
export default Paso;
